/**
 * Breadcrumb Configuration
 *
 * Define route-to-breadcrumb mappings here.
 * - Exact routes: map directly as keys
 */

/** Breadcrumb labels for exact route matches */
const EXACT_BREADCRUMBS: Record<string, string> = {
  '/admin/settings': 'Admin Settings',
  '/videos': 'My Videos',
  '/admin': 'Admin Settings',
}

/**
 * Get breadcrumb label for a given pathname
 * @param pathname - The current URL pathname
 * @returns The breadcrumb label or undefined if no match
 */
export const getBreadcrumbLabel = (pathname: string): string | undefined => {
  // Check exact matches first (faster)
  if (EXACT_BREADCRUMBS[pathname]) {
    return EXACT_BREADCRUMBS[pathname]
  }

  return undefined
}
